import { differenceInDays, endOfDay, startOfDay } from 'date-fns';
import { DATES_OPTIONS_ENUM } from '@dfl/mui-admin-layout';
import { useMemo } from 'react';

export enum INTERVAL {
  hourly = 'hourly',
  daily = 'daily',
  monthly = 'monthly',
  yearly = 'yearly',
}

export const useInterval = (value?: string, defaultInterval: INTERVAL = INTERVAL.daily) => {
  return useMemo(() => {
    if (!value) {
      return defaultInterval;
    }
    switch (value) {
      case DATES_OPTIONS_ENUM.TODAY:
      case DATES_OPTIONS_ENUM.YESTERDAY:
        return INTERVAL.hourly;
      case DATES_OPTIONS_ENUM.LAST_SEVEN_DAYS:
      case DATES_OPTIONS_ENUM.THIS_WEEK:
      case DATES_OPTIONS_ENUM.CURRENT_MONTH:
      case DATES_OPTIONS_ENUM.LAST_MONTH:
      case DATES_OPTIONS_ENUM.LAST_THIRTY_DAYS:
      case DATES_OPTIONS_ENUM.LAST_NINETY_DAYS:
        return INTERVAL.daily;
      case DATES_OPTIONS_ENUM.LAST_TWELVE_MONTHS:
      case DATES_OPTIONS_ENUM.THIS_YEAR:
      case DATES_OPTIONS_ENUM.LAST_ONE_YEAR:
        return INTERVAL.monthly;
      default: {
        const range = stringToRange(value);
        if (range) {
          const dif = differenceInDays(range[1], range[0]);
          if (!dif || dif < 6) return INTERVAL.hourly;
          if (dif < 90) return INTERVAL.daily;
        }
        return INTERVAL.monthly;
      }
    }
  }, [defaultInterval, value]);
};

export const stringToRange = (value: string): Date[] | undefined => {
  if (!value) return undefined;
  const range = value.split('_');

  return range?.map((d, index) => {
    if (index === 0) return startOfDay(new Date(d));
    return endOfDay(new Date(d));
  });
};
